module.exports = __webpack_public_path__ + "4f4d89b38edbc71f58620edcf535b5e0.jpg";